import { useEffect, useState } from "react";
import { OfficerLayout } from "@/components/OfficerLayout";
import { useLang } from "@/context/LangContext";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { Briefcase, Truck, Star } from "lucide-react";

export default function Stakeholders() {
  const { lang } = useLang();
  const { user } = useAuth();
  const [tab, setTab] = useState("contractor");
  return (
    <OfficerLayout>
      <div>
        <div className="mb-5">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-[#E87722]">Procurement</div>
          <h1 className="mt-2 font-heading text-3xl font-bold text-slate-900 flex items-center gap-2">
            <Briefcase className="w-7 h-7 text-[#0A3161]" />
            {lang === "hi" ? "ठेकेदार एवं विक्रेता" : "Contractors & Vendors"}
          </h1>
        </div>
        <div className="flex border-b border-slate-200 mb-4">
          {[
            { k: "contractor", label: lang === "hi" ? "ठेकेदार" : "Contractors", icon: Briefcase },
            { k: "vendor", label: lang === "hi" ? "विक्रेता" : "Vendors", icon: Truck },
          ].map((x) => {
            const I = x.icon;
            return (
              <button key={x.k} onClick={() => setTab(x.k)} data-testid={`sh-tab-${x.k}`}
                className={`px-5 py-3 text-sm font-semibold border-b-2 inline-flex items-center gap-1.5 ${tab === x.k ? "border-[#E87722] text-[#0A3161]" : "border-transparent text-slate-500"}`}>
                <I className="w-4 h-4" /> {x.label}
              </button>
            );
          })}
        </div>
        <List kind={tab} user={user} />
      </div>
    </OfficerLayout>
  );
}

function List({ kind, user }) {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/stakeholders", { params: { kind } }).then((r) => setRows(r.data));
  }, [kind]);
  return (
    <div className="rounded-md border border-slate-200 bg-white overflow-x-auto">
      <table className="w-full text-sm" data-testid={`sh-table-${kind}`}>
        <thead className="bg-slate-50 text-[10px] uppercase tracking-wider text-slate-500 font-semibold">
          <tr><th className="text-left px-4 py-3">Reg No.</th><th className="text-left px-4 py-3">Name / Firm</th>
              <th className="text-left px-4 py-3">Mobile</th><th className="text-left px-4 py-3">Categories</th>
              <th className="text-center px-4 py-3">Rating</th><th className="text-right px-4 py-3">Completed</th>
              <th className="text-center px-4 py-3">Status</th></tr>
        </thead>
        <tbody>
          {rows.map((s) => (
            <tr key={s.id} className="border-t border-slate-100">
              <td className="px-4 py-3 font-mono text-xs">{s.reg_no}</td>
              <td className="px-4 py-3"><div className="font-medium">{s.name}</div><div className="text-xs text-slate-500">{s.firm_name}</div></td>
              <td className="px-4 py-3 font-mono text-xs">{s.mobile}</td>
              <td className="px-4 py-3 text-xs">{s.categories?.join(", ")}</td>
              <td className="px-4 py-3 text-center">
                <span className="inline-flex items-center gap-1 text-amber-600 font-semibold"><Star className="w-3 h-3 fill-current" /> {s.rating}</span>
              </td>
              <td className="px-4 py-3 text-right font-mono">{s.completed_projects}</td>
              <td className="px-4 py-3 text-center">
                {s.blacklisted ? <span className="text-[10px] uppercase px-2 py-0.5 rounded bg-red-50 text-red-700 font-semibold">Blacklisted</span>
                                : <span className="text-[10px] uppercase px-2 py-0.5 rounded bg-emerald-50 text-emerald-700 font-semibold">Active</span>}
              </td>
            </tr>
          ))}
          {rows.length === 0 && <tr><td colSpan={7} className="py-10 text-center text-slate-400">No {kind}s</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
